import styled from 'styled-components';

export const Title = styled.h3`
    font-size: 24px;
    font-weight: 700;
`;
